var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header-loop"},[_c('a-carousel',{staticClass:"header-carousel",attrs:{"autoplay":""}},_vm._l((_vm.bannerList),function(item,index){return _c('div',{key:index},[_c('a',{attrs:{"href":item.link,"target":"_blank"}},[_c('img',{attrs:{"src":item.picUrl,"alt":item.title}})])])}),0)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }